import ShareDialog from '@components/share';
import type { StudioUser } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { MainHeader } from './base/mainHeader/main-header.comp';
import { HeaderRoot } from './header.comp';

type HeaderProps = {
  user: StudioUser;
};

const Header = ({ user }: HeaderProps) => {
  const processId = useParams()[ParamsList.ProcessId] as string;
  const [openModalShare, setOpenModalShare] = useState(false);

  return (
    <HeaderRoot>
      <MainHeader user={user} />
      {processId && (
        <ShareDialog
          key="modal"
          openModalShare={openModalShare}
          processId={processId}
          setOpenModalShare={setOpenModalShare}
          user={user}
        />
      )}
    </HeaderRoot>
  );
};

export default observer(Header);
